{
  "bank": "Thẻ ngân hàng",
  "alipay": "Alipay",
  "wechat": "WeChat",
  "ermb": "Ví kỹ thuật số",
  "qq": "QQ"
}
